import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../components/SpectraNavbar";
import Footer from "../components/Footer";
import { CardA } from "../components/ui/Cards";
import Notes from "../components/Notes";
import { useExperiment } from "../api";
import ChipAccordionItem from "../components/ChipAccordionItem";
import DownloadDataAVR from "../components/DownloadDataAVR";

import { DateTime } from "luxon";
import { Accordion } from "react-bootstrap";

const scanTypes = { BG: "Background", "trace-burst": "Trace" };

export default function ViewExperiment() {
  const { id } = useParams();
  const [isExpanded, setIsExpanded] = useState([]);

  // api
  const {
    data: experiment,
    isError: experimentError,
    isLoading: experimentLoading,
    isSuccess: experimentSuccess,
  } = useExperiment(id);

  console.log("experimentData:", experiment);

  const handleAccordionClick = (chipId) => {
    console.log("chipId:", chipId);

    // if (isExpanded.includes(chipId)) {
    //   setIsExpanded((prev) => prev.filter((id) => id !== chipId));
    // } else {
    //   setIsExpanded((prev) => [...prev, chipId]);
    // }
    setIsExpanded(chipId);
  };

  if (experimentError) {
    return (
      <div className='flex-container'>
        <Navbar signedIn={false} />
        <div
          className='px-sm-3 px-lg-5 py-3 flex-body'
          style={{ marginTop: "79px" }}
        >
          <CardA title='Experiment not found' />
        </div>
        <Footer />
      </div>
    );
  }

  if (experimentLoading) {
    return (
      <div className='flex-container'>
        <Navbar signedIn={false} />
        <div
          className='px-sm-3 px-lg-5 py-3 flex-body'
          style={{ marginTop: "79px" }}
        >
          <div
            className='alert mx-3'
            style={{
              backgroundColor: "#7ECBF7",
              fontWeight: "bold",
            }}
            role='alert'
          >
            Fetching experiment ...
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  if (experimentSuccess) {
    const {
      _id,
      experimentName,
      processedDate,
      numAnalytes,
      numChips,
      notes,
      chipIds,
      experimentParams,
    } = experiment;

    return (
      <div className='flex-container'>
        <Navbar signedIn={false} />
        <div
          className='px-sm-3 px-lg-5 py-3 flex-body'
          style={{ marginTop: "79px" }}
        >
          <CardA>
            <div className='d-flex flex-grow-1 flex-column flex-lg-row justify-content-between'>
              <div className='d-flex flex-column col-12 col-lg-4'>
                <div
                  className='flex-grow-1 m-3 rounded-4 p-3 shadow'
                  style={{ background: "#DBDBDB" }}
                >
                  <div className='d-flex justify-content-between flex-wrap'>
                    <button
                      type='button'
                      className='back-button'
                      onClick={() => {
                        window.history.back();
                      }}
                    >
                      <i className='bi bi-arrow-left pe-1'></i>
                      Back
                    </button>
                    <DownloadDataAVR
                      ids={chipIds}
                      needsScanData={true}
                      experimentName={experimentName}
                    />
                  </div>
                  <div className='d-flex justify-content-between mb-3 flex-wrap gap-2'>
                    <div className='d-flex flex-column justify-content-between'>
                      <div className=''>
                        <div className='h4'>{experimentName}</div>
                      </div>
                      <div className='fw-semibold'>
                        {DateTime.fromISO(processedDate).toLocaleString(
                          DateTime.DATETIME_MED
                        )}
                      </div>
                      <div>
                        Analytes: {experimentParams.analytes.join(", ")}
                      </div>
                    </div>
                  </div>
                  <div className='d-flex flex-column text-nowrap justify-content-start mb-3'>
                    <div className='h5 text-primary text-wrap'>
                      Experiment Parameters:
                    </div>
                    <div className='d-flex justify-content-around flex-wrap gap-2'>
                      {experimentParams.rounds.map((round, index) => {
                        return (
                          <div key={index}>
                            <div className='fw-semibold fs-6'>
                              Round {index + 1}
                            </div>
                            <div>Scan Type: {scanTypes[round.scanType]}</div>
                            <div>Laser Power: {round.laserPower} mW</div>
                            <div>
                              Integration Time: {round.integrationTime} ms
                            </div>
                            <div>Scans per Spot: {round.scansPerSpot}</div>
                            <div>Z-height: {round.zHeight} mm</div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className='d-flex flex-column text-nowrap justify-content-start gap-3 fs-6 fw-semibold'>
                    <Notes savedNotes={notes} id={_id} type='experiment' />
                  </div>
                </div>
              </div>
              <div className='d-flex flex-column col-12 col-lg-8'>
                {/* <div
                  className='flex-grow-1 m-3 rounded-4 shadow'
                  style={{ background: "#DBDBDB" }}
                > */}
                <Accordion className='m-3'>
                  {chipIds.map((chipId, index) => {
                    return (
                      <ChipAccordionItem
                        id={chipId}
                        key={index}
                        index={index}
                        isExpanded={isExpanded}
                        onClick={handleAccordionClick}
                      />
                    );
                  })}
                </Accordion>
                {/* </div> */}
              </div>
            </div>
          </CardA>
        </div>
        <Footer />
      </div>
    );
  }
  return null;
}
